/**
 * Key over everything that feeds story generation. A generated story preview is only reusable while
 * this key is unchanged; otherwise it must be regenerated (e.g. concept rewritten, template swapped or dropped).
 */
export function storyInputsKey(input: {
  additionalComments?: string | null;
  templateId?: string | null;
  language?: string | null;
  characterNames?: Array<string | null | undefined> | null;
  characterAges?: Array<string | number | null | undefined> | null;
  characterGenders?: Array<string | null | undefined> | null;
  readingLevel?: string | null;
}): string {
  return JSON.stringify([
    (input.additionalComments ?? '').trim(),
    input.templateId ?? null,
    input.language ?? null,
    (input.characterNames ?? []).map((n) => (n ?? '').trim()),
    (input.characterAges ?? []).map((x) => String(x ?? '').trim()),
    (input.characterGenders ?? []).map((g) => (g ?? '').trim().toLowerCase()),
    input.readingLevel ?? 'picture',
  ]);
}
